import React from 'react';
import { useIntl } from 'react-intl';

import DateInput, { DateInputProps } from 'carbon-react/lib/components/date';

import { ForecastFormElementIds } from './types';

export type ForecastFromProps = Omit<DateInputProps, 'name' | 'id' | 'inputHint'>;

export const ForecastFrom = ({ ...props }: ForecastFromProps) => {
  const intl = useIntl();
  let inputHint = '';

  if (props.disabled) {
    inputHint = intl.formatMessage({
      id: 'predict.create_forecast.forecast_data_always_shows_from_last_sync',
      defaultMessage: 'Forecast data always shows from last sync'
    });
  } else {
    inputHint = intl.formatMessage({
      id: 'predict.create_forecast.date_format',
      defaultMessage: 'DD/MM/YYYY'
    });
  }

  return (
    <DateInput
      name={ForecastFormElementIds.From}
      id={ForecastFormElementIds.From}
      required
      inputHint={inputHint}
      {...props}
    />
  );
};
